import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {BsModalService} from 'ngx-bootstrap';

import {Act, District, Mtp, Region} from 'app/models/act';
import {ApiService} from 'app/services/api.service';
import {AppConfig} from 'app/app.config';
import * as moment from 'moment';

@Component({
  selector: 'app-acts',
  templateUrl: './acts.component.html',
  styleUrls: ['./acts.component.css']
})

export class ActsComponent implements OnInit {

  acts: Array<Act> = [];

  defaultFilters = {
    actNum: '',
    region: 0,
    district: 0,
    mtp: 0,
    dateRange: [moment().subtract(90, 'day').toDate(), moment().toDate()]
  }

  filters = {
    actNum: '',
    region: 0,
    district: 0,
    mtp: 0,
    dateRange: [moment().subtract(90, 'day').toDate(), moment().toDate()]
  };


  page = 1;
  pageSize = 15;
  totalItems = 0;

  isLoading = false;
  isCSVLoading = false;

  orderBy = 'createdAt';

  regions: Region[];

  districts: District[];

  mtps: Mtp[];


  constructor(private modalService: BsModalService, private service: ApiService, private config: AppConfig, private datePipe: DatePipe) {
    this.service.act.regions().subscribe(regions => {
      this.regions = regions;
    });
  }

  ngOnInit() {
    this.load(false);
  }

  onRegionChange(id: number) {

    const selected = this.regions.find(region => region.id == id);

    if (selected) {
      this.districts = selected.districts;
      this.mtps = [];
      this.filters.district = 0;
      this.filters.mtp = 0;
    }

  }

  onDistrictChange(id: number) {
    const selected = this.districts.find(d => d.id == id);

    if (selected) {
      this.mtps = selected.mtps;
    }
  }

  sortChange(orderBy) {
    this.orderBy = orderBy;
    this.load();
  }

  get_filters() {
    const filters = {};

    if (this.filters.actNum != '') {
      filters['actNum'] = this.filters.actNum;
    }

    if (this.filters.dateRange) {
      filters['from'] = moment(this.filters.dateRange[0]).format('DD.MM.YYYY')
      filters['to'] = moment(this.filters.dateRange[1]).format('DD.MM.YYYY')
    }

    if (this.filters.region != 0) {
      filters['regionId'] = this.filters.region;
    }

    if (this.filters.district != 0) {
      filters['districtId'] = this.filters.district;
    }

    if (this.filters.mtp != 0) {
      filters['mtpId'] = this.filters.mtp;
    }

    return filters;
  }

  reset() {
    this.filters = this.defaultFilters;
    this.load();
  }

  load(isLoading = true) {

    this.isLoading = isLoading;

    this.service.act.getAll(this.page, this.pageSize, this.get_filters(), this.orderBy).subscribe(response => {
      if (response.code && response.code != 0) {

      }
      this.acts = [];
      this.totalItems = response.total ? response.total : 0;
      response.acts.map(act => this.acts.push(Act.create(act)));
      this.isLoading = false;
    });

  }

  pageChanged($ev: any): void {
    this.page = $ev.page;
    this.load(false);
  }

  changeStatus($ev, claim) {
    let cancel_reason = '';

    if ($ev.target.value == 4) {
      cancel_reason = prompt('Пожалуйста введите причину отмены');

      if (cancel_reason === null) {
        $ev.target.value = claim.status;
        return;
      }
    }

    this.service.act.updateStatus(claim._id, $ev.target.value, cancel_reason).subscribe(response => {
      if (response.api_status == 0) {
        claim.updateStatuses($ev.target.value);
      }
    });
  }

  generateCSV() {
    this.isCSVLoading = true;
    this.service.act.getAll(1, this.totalItems, this.get_filters()).subscribe(response => {

    });
  }

  handleDates() {
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/views/acts/acts.component.ts